interface ArrowProps {
  color?: 'blue' | 'black' | 'white';
  direction?: 'left' | 'right' | 'up' | 'down';
  className?: string;
}

const Arrow = ({ color = 'black', direction = 'right', className = '' }: ArrowProps) => {
  const colorMap = {
    blue: '#004EFF',
    black: '#101010',
    white: '#FFFFFF',
  };

  const rotateMap = {
    right: 'rotate-0',
    down: 'rotate-90',
    left: 'rotate-180',
    up: '-rotate-90',
  };

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${rotateMap[direction]} ${className}`}
    >
      <path
        d="M1 8.25C0.585786 8.25 0.25 8.58579 0.25 9C0.25 9.41421 0.585786 9.75 1 9.75L1 8.25ZM1 9.75L17 9.75L17 8.25L1 8.25L1 9.75Z"
        fill={colorMap[color]}
      />
      <path
        d="M9 1L17 9L9 17"
        stroke={colorMap[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Arrow;
